export const WORKER_ROLES = [
  {
    key: "healthcare_assistant",
    label: "Healthcare Assistant",
    description: "Front-line care delivery in residential or community settings.",
  },
  {
    key: "senior_care_assistant",
    label: "Senior Care Assistant",
    description: "Supervisory care role — adds Medication Administration and (desirable) Level 3 Diploma.",
  },
  {
    key: "registered_nurse",
    label: "Registered Nurse",
    description: "NMC-registered clinical practitioner. Requires PIN + monthly NMC register check.",
  },
  {
    key: "chef",
    label: "Chef",
    description: "Kitchen lead — adds a catering/culinary qualification on top of standard training.",
  },
  {
    key: "kitchen_assistant",
    label: "Kitchen Assistant",
    description: "Kitchen support role — standard training only.",
  },
];

export const STATUS_META = {
  approved: {
    label: "Approved",
    className: "bg-emerald-50 text-emerald-700 border-emerald-200",
    dot: "bg-emerald-500",
  },
  pending: {
    label: "In review",
    className: "bg-amber-50 text-amber-800 border-amber-200",
    dot: "bg-amber-500",
  },
  rejected: {
    label: "Rejected",
    className: "bg-rose-50 text-rose-700 border-rose-200",
    dot: "bg-rose-500",
  },
  missing: {
    label: "Not uploaded",
    className: "bg-slate-50 text-slate-600 border-slate-200",
    dot: "bg-slate-400",
  },
  expiring_soon: {
    label: "Expiring soon",
    className: "bg-amber-50 text-amber-800 border-amber-300",
    dot: "bg-amber-500",
  },
  expired: {
    label: "Expired",
    className: "bg-rose-50 text-rose-700 border-rose-300",
    dot: "bg-rose-600",
  },
  action_required: {
    label: "Action required",
    className: "bg-rose-50 text-rose-700 border-rose-200",
    dot: "bg-rose-500",
  },
};

export const OVERALL_META = {
  compliant: { label: "Fully compliant", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  in_progress: { label: "In progress", className: "bg-teal-50 text-teal-700 border-teal-200" },
  action_required: { label: "Action required", className: "bg-rose-50 text-rose-700 border-rose-200" },
  outstanding: { label: "Not started", className: "bg-slate-100 text-slate-700 border-slate-200" },
};

export function roleLabel(key) {
  return WORKER_ROLES.find((r) => r.key === key)?.label || key || "—";
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
  } catch (_) {
    return iso;
  }
}

export function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(iso + (iso.length === 10 ? "T00:00:00" : ""));
  const ms = d.getTime() - Date.now();
  return Math.round(ms / (1000 * 60 * 60 * 24));
}
